import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import MediaAddButton from './MediaAddButton';
import MediaThumbnail from './MediaThumbnail';

const MediaSelector = ({ media, setMedia }) => {
  const [lastAction, setLastAction] = useState('');
  const lastThumbnailRef = useRef(null);

  // Image manipulation methods
  const addMedia = files => {
    setLastAction('add');
    setMedia([...media, ...files]);
  };
  const removeMedia = index => {
    setLastAction('remove');
    const newArray = [...media];
    newArray.splice(index, 1);
    setMedia(newArray);
  };

  // Scroll to last thumbnail if the last action was adding
  useEffect(() => {
    if (lastAction === 'add' && lastThumbnailRef.current) {
      lastThumbnailRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [lastAction, lastThumbnailRef]);

  return (
    <div className='c-media-selector'>
      <div className='c-media-selector__files'>
        {media.map((file, index) => (
          <MediaThumbnail
            key={file.file.name}
            alt={file.file.name}
            onRemove={() => removeMedia(index)}
            src={file.preview}
            ref={index === media.length - 1 ? lastThumbnailRef : null}
          />
        ))}
      </div>
      <div className='c-media-selector__upload'>
        <MediaAddButton handleNewFiles={addMedia} />
      </div>
    </div>
  );
};

MediaSelector.propTypes = {
  media: PropTypes.array,
  setMedia: PropTypes.func
};

export default MediaSelector;
